<template lang="pug">
#informacoes-monitoramento
    .row.h-100
        .col-3
            item-informacoes(
                title='Volume',
                :iconClass='getCulturaIcon()',
                formato='0.00 a',
                :value='volume',
                :unidade='isAlgodao() ? "kg" : "sc"',
                justify='flex-start',
                separados
            )

        .col-3
            item-informacoes(
                title='Área de plantio',
                iconClass='mdi mdi-tractor',
                formato='0.00 a',
                :value='value.areaPlantioIdentificadaHa',
                unidade='ha',
                justify='flex-start',
                separados
            )

        .col-3
            item-informacoes(
                title='Produtividade',
                iconClass='mdi mdi-weight',
                formato='0.00 a',
                :value='produtividadeEsperada',
                :unidade='isAlgodao() ? "kg/ha" : "sc/ha"',
                justify='flex-start',
                separados
            )

        .col-3
            item-informacoes(
                title='Produção',
                iconClass='mdi mdi-chart-bar',
                formato='0.00 a',
                :value='producaoEsperada',
                unidade='ton',
                justify='flex-start',
                separados
            )
</template>

<script>
import ItemInformacoes from './ItemInformacoes';

import { mapGetters } from 'vuex';

import { CULTURA_ICONS } from '@/utils/helpers/icon-mapper';

import { CULTURAS } from '@/utils/TipoCultura';

export default {
    components: { ItemInformacoes },

    props: {
        value: {
            type: Object,
            required: true
        }
    },

    methods: {
        getCulturaIcon() {
            return CULTURA_ICONS[this.culturaSelecionada];
        },

        isAlgodao() {
            return this.culturaSelecionada === CULTURAS.ALGODAO.codigo;
        }
    },

    computed: {
        ...mapGetters({
            culturaSelecionada: 'culturaSelecionada'
        }),

        volume() {
            if (this.culturaSelecionada === CULTURAS.SOJA.codigo) {
                return this.value.volumeSojaSc;
            } else if (this.culturaSelecionada === CULTURAS.MILHO.codigo) {
                return this.value.volumeMilhoSc;
            } else if (this.culturaSelecionada === CULTURAS.ALGODAO.codigo) {
                return this.value.volumeAlgodaoSc;
            }

            return null;
        },

        produtividadeEsperada() {
            return this.culturaSelecionada === CULTURAS.ALGODAO.codigo
                ? null
                : this.value.produtividadeEstimadaSacas;
        },

        producaoEsperada() {
            return this.culturaSelecionada === CULTURAS.ALGODAO.codigo
                ? null
                : this.value.producaoEstimadaTon;
        }
    }
};
</script>

<style lang="scss" scoped>
#informacoes-monitoramento {
    width: 100%;
    height: 81px;
}
</style>
